module.exports = __webpack_public_path__ + "img/icon-star-filled.fb0304ab.svg";